const routes = [{
    name: '个人中心',
    value: 'person',
    link: '/seeker/person.html',
    sub: [{
        name: '个人中心-视频双选会',
        value: 'video_meeting',
        link: '/seeker/person/video_meeting.html'
      }, {
        name: '个人中心-云宣讲',
        value: 'preach_meeting',
        link: '/seeker/person/preach_meeting.html'
      }, {
        name: '个人中心-企业邀约',
        value: 'c_invited',
        link: '/seeker/person/c_invited.html'
      }, {
        name: '个人中心-最近投递',
        value: 'r_delivery',
        link: '/seeker/person/r_delivery.html'
      }, {
        name: '个人中心-我的申请',
        value: 'm_apply',
        link: '/seeker/person/m_apply.html'
      }, {
        name: '个人中心-我的收藏',
        value: 'm_collection',
        link: '/seeker/person/m_collection.html'
      }, {
        name: '个人中心-账号设置',
        value: 'm_setting',
        link: '/seeker/person/m_setting.html'
      }, {
        name: '个人中心-简历',
        value: 'resume',
        link: '/seeker/person/resume.html'
      },
      {
        name: '完善信息',
        value: 'perfect',
        link: '/seeker/register.html',
      }
    ]
  },
  {
    name: '职位',
    value: 'job',
    link: '/seeker/job.html',
    sub: [{
        name: '职位详情',
        value: 'jobfair_job',
        link: '/seeker/job/jobfair_job.html',
      },
      {
        name: '公司主页',
        value: 'company_detail',
        link: '/seeker/company_detail.html',
      }
    ]
  },
  {
    name: '双选会',
    value: 'offline_jobfair',
    link: '/seeker/offline_jobfair.html',
    sub: [{
      name: '双选会详情',
      value: 'offline_detail',
      link: '/seeker/offline_jobfair/offline_detail.html',
    }, {
      name: '双选会列表页',
      value: 'offline_search',
      link: '/seeker/offline_jobfair/offline_search.html',
    },{
      name: '双选会企业大厅',
      value: 'offline_company',
      link: '/seeker/offline_company.html'
    },]
  },
  {
    name: '云宣讲',
    value: 'career_talk',
    link: '/seeker/career_talk.html',
    sub: [{
      name: '云宣讲列表',
      value: 'career_talk_search',
      link: '/seeker/career_talk/career_talk_search.html',
    }, {
      name: '云宣讲详情',
      value: 'career_talk_detail',
      link: '/seeker/career_talk/career_talk_detail.html',
    }]
  },
  {
    name: '视频双选会',
    value: 'jobfair',
    link: '/seeker/',
    sub: [{
        name: '首页',
        value: 'home',
        link: '/seeker/jobfair.html',
      },
      {
        name: '双选会详情',
        value: 'jobfair_detail',
        link: '/seeker/jobfair/jobfair_detail.html',
      },
      {
        name: '双选会列表页',
        value: 'jobfair_search',
        link: '/seeker/jobfair/jobfair_search.html',
      },
      {
        name: '双选会企业大厅',
        value: 'jobfair_company',
        link: '/seeker/jobfair_company.html',
        sub: [{
          name: '双选会公司详情',
          value: 'jobfair_company_detail',
          link: '/seeker/jobfair_company/jobfair_company_detail.html',
        }, ]
      },
    ],
  },
  {
    name: '公司网申',
    value: 'application',
    link: '/seeker/application.html',
    sub: [{
      name: '网申详情',
      value: 'application_detail',
      link: '/seeker/application/application_detail.html',
    }, ],
  },
  {
    name: '首页',
    value: 'home',
    link: '/seeker/home.html',
    sub: [{
      name: '近日招聘',
      value: 'kzp_recruitment',
      link: '/seeker/home/kzp_recruitment.html',
    }, ],
  },
]

const routesObj = (function () {
  var o = {}

  var format = function (data) {
    data.forEach((item) => {
      if (item.link === undefined || item.value === undefined) {
        return
      }

      o[item.value] = item

      if (item.sub) {
        format(item.sub)
      }
    })
  }

  format(routes)

  return o
})()

export {
  routes,
  routesObj
}



// WEBPACK FOOTER //
// ./src/routes/index.js